import { ICartProduct, IConfig, IProduct } from '../interfaces'

export interface AnalyticsPurchaseItem {
  item_id: string
  item_name: string
  discount?: number
  price: number
  quantity: number
  index: number
  item_list_name?: string
}

interface IGetGTMEventsPayloadArgs {
  product: IProduct
  quantity?: number
  itemListName?: string
  config?: IConfig
}

interface IGTMEventsPayload {
  items: AnalyticsPurchaseItem[]
  currency: string
  value: number
}
export type ICartItemForAnalytics = Partial<ICartProduct>

export const getAnalyticsItems = (cart: {
  items: ICartItemForAnalytics[]
}): AnalyticsPurchaseItem[] => {
  const items = cart.items.map(parseAnalyticsItems)
  return items
}

export const getGTMEventsPayload = ({
  product,
  quantity = product.quantity || 1,
  itemListName,
  config,
}: IGetGTMEventsPayloadArgs): IGTMEventsPayload => ({
  items: [
    parseAnalyticProductItem(
      {
        ...product,
        quantity,
      },
      0,
      itemListName,
    ),
  ],
  currency:
    config?.options?.currencyPrefix || config?.options?.currencyCode || '',
  value: (product.price || 0) * quantity,
})

const getAnalyticsItem = (
  item: IProduct,
  itemListName?: string,
): AnalyticsPurchaseItem => {
  return parseAnalyticProductItem(item, 0, itemListName)
}

const parseAnalyticProductItem = (
  item: IProduct,
  index: number,
  itemListName?: string,
): AnalyticsPurchaseItem => ({
  item_id: item.sku,
  item_name: item.name,
  price: item.price || 0,
  quantity: item.quantity || 1,
  index,
  item_list_name: itemListName,
})

const parseAnalyticsItems = (
  {
    sku = '',
    name = '',
    price = 0,
    quantity = 0,
    discounts = 0,
    promotionalQty = 0,
  }: ICartItemForAnalytics,
  index: number,
): AnalyticsPurchaseItem => ({
  item_id: sku,
  item_name: name,
  discount: promotionalQty ? price : discounts,
  price: price,
  quantity: quantity,
  index,
})

export default getAnalyticsItems
export { getAnalyticsItem, parseAnalyticsItems }
